import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

export * from './lib/old/models';
export * from './lib/old/mocks';
export * from './lib/old/base-eplus-wizard/base-eplus-wizard.component';
export * from './lib/old/eplus-progressive-address-form';
export * from './lib/old/eplus-progressive-personal-details-form';
export * from './lib/old/eplus-progressive-confirmation-form';
export * from './lib/old/usage-questionnaire/usage-questionnaire';
export * from './lib/old/renderings';
export * from './lib/old/sustainability';
export * from './lib/old/utils';
export * from './lib/old/page-back-button';
export * from './lib/old/reusable-forms';

export * from './lib/store/+state';
export * from './lib/store/generators';

export { FehSharedBootstrapModule } from './lib/feh-shared.bootstrap.module';
export { FehSharedLazyModule } from './lib/feh-shared.lazy.module';
export { ScFieldValuePipe } from './lib/pipes/sc-field-value.pipe';

const loadChildren = () =>
  import('./lib/feh-shared.lazy.module').then(
    (module) => module.FehSharedLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const fehSharedLazyImports: ComponentNameAndModule[] = [
  defineImport('PageBackButton'),
];

export { fehSharedLazyImports };
